// Generated by @sgflabs/opticomm-sdk-codegen. Do not edit.
// Run `yarn workspace @sgflabs/opticomm-sdk-codegen generate` after changing a backend route.
import { buildPath } from "../../core/path.js";
export const createStoreProductDocuments = (client) => ({
    /**
     * `GET /store/product-documents/:id/signed-url`
     *
     * The response is not yet typed — pass a type argument to narrow it,
     * or add an entry to TYPE_OVERRIDES in the codegen package.
     *
     * @operationId StoreGetProductDocumentSignedUrl
     * @source packages/medusa-plugin-product-documents/src/api/store/product-documents/[id]/signed-url/route.ts
     */
    retrieveSignedUrl: (id, query, headers) => client.fetch(buildPath("/store/product-documents/:id/signed-url", [id]), { method: "GET", query, headers }),
});
//# sourceMappingURL=product-documents.js.map